export const headerMenuList = [
  { link: "/#features", label: "Features" },
  { link: "/#howItWorks", label: "How It Works" },
  { link: "/#pricingPlans", label: "Pricing Plans" },
];
